import React from 'react';
import { motion } from 'framer-motion';

const Reports = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-7xl mx-auto"
      >
        <div className="text-center py-12">
          <div className="w-24 h-24 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <span className="text-4xl">📊</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Reportes y Métricas
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Visualizaciones avanzadas con gráficos de barras, líneas y burndown charts
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="card p-6 text-center">
              <div className="text-3xl mb-3">📈</div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Avance por Sprint</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Seguimiento del progreso y velocidad del equipo
              </p>
            </div>
            <div className="card p-6 text-center">
              <div className="text-3xl mb-3">👤</div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Productividad Individual</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Métricas de rendimiento por persona
              </p>
            </div>
            <div className="card p-6 text-center">
              <div className="text-3xl mb-3">🚫</div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Tareas Bloqueadas</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Identificación de cuellos de botella
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Reports;


























